<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    if(this.storage.getLang() == null || (this.storage.getLang() + '').length === 0) {
      this.storage.setLang(navigator.language === 'zh-CN' ? '1' : '0')
    }

    this.$i18n.locale = this.storage.getLang() == '0' ? 'en-US' : 'zh-CN'
    document.title = this.$t('lang.comm.title')
    document.querySelector('meta[name="keywords"]').setAttribute("content", this.$t('lang.comm.keywords'));
    document.querySelector('meta[name="description"]').setAttribute("content", this.$t('lang.comm.description'));
  }
}
</script>

<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: #a9a9a9;
}

* {
  padding: 0;
  margin: 0;
  border: none;
}

body, html, #app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  color: #515a6e;
  font-size: 12px;
  background: #fff;
}

a {
  color: inherit;
  font-size: inherit;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue